import React from 'react';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { useQuery } from 'urql';

import ETicketPage from '@/components/shop/ETicketPage';
import GiftCardPage from '@/components/shop/GiftCardPage';
import query from '@/graphql/queries/user.graphql';
import useStore from '@/hooks/useStore';
import { getServerSidePropsWithGlobalData } from '@/lib/getServerSideProps';
import { withUrql } from '@/lib/urqlClient';
import { ErrorPage } from '@/pages/_error';

const Product = () => {
  const { exclusive, uuid } = useStore('userStore');

  const router = useRouter();
  let product: ETicketFragment | GiftCardFragment;
  let galleryImages: ImageObject[] | undefined;

  const [{ data, error, fetching }] = useQuery<UserQuery>({
    query,
    variables: {
      uuid,
      productPage: true,
      slug: router.query.slug,
      exclusive,
    },
  });

  if (!fetching && data?.product) {
    product = data.product;

    if ('gallery' in data.product) {
      galleryImages = data?.product?.gallery as ImageObject[];
    }
  } else {
    return <ErrorPage statusCode={404} err={error} />;
  }

  return product.__typename === 'eTickets_Product' ? (
    <ETicketPage product={product} galleryImages={galleryImages} />
  ) : (
    <GiftCardPage giftcard={product} />
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) =>
  await getServerSidePropsWithGlobalData(ctx, async (ctx) => {
    const { urqlClient, nextCtx, stores } = ctx;
    const slug = nextCtx?.query.slug;

    await urqlClient
      .query<UserQuery, UserQueryVariables>(query, {
        uuid: stores.userStore.uuid,
        slug,
        productPage: true,
        exclusive: stores.userStore.exclusive,
      })
      .toPromise();

    return { props: undefined };
  });

export default withUrql(Product);
